export default function ThankYouSlide() {
  return (
    <div className="w-full h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center overflow-hidden relative">
      {/* Animated background circles */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-lime-400 rounded-full opacity-10 blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-lime-400 rounded-full opacity-10 blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      
      {/* Main content */}
      <div className="relative z-10 text-center space-y-8">
        {/* Thank You text */}
        <div className="space-y-4">
          <h1 className="text-7xl md:text-8xl lg:text-9xl font-bold text-lime-400 tracking-tight animate-fade-in">
            Thank You
          </h1>
          <div className="h-1 w-48 mx-auto bg-gradient-to-r from-transparent via-lime-400 to-transparent"></div>
        </div>
        
        {/* Subtitle */}
        {/* <p className="text-2xl md:text-3xl text-gray-300 font-light tracking-wide">
          For Your Attention
        </p> */}
        
        {/* Decorative elements */}
        <div className="flex items-center justify-center gap-4 pt-8">
          <div className="w-3 h-3 bg-lime-400 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-lime-400 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          <div className="w-3 h-3 bg-lime-400 rounded-full animate-bounce" style={{animationDelay: '0.4s'}}></div>
        </div>
        
        {/* Optional contact section - uncomment if needed */}
        {/* <div className="pt-12 space-y-2">
          <p className="text-gray-400 text-lg">Questions?</p>
          <p className="text-lime-400 text-xl font-semibold">yourname@email.com</p>
        </div> */}
      </div>
      
      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-32 h-32 border-t-4 border-l-4 border-lime-400 opacity-50"></div>
      <div className="absolute bottom-0 right-0 w-32 h-32 border-b-4 border-r-4 border-lime-400 opacity-50"></div>
    </div>
  );
}